import IconBox from '../iconboxes/IconBox'
import classes from './SimpleBoxDisplay.module.css'

export default function SimpleBoxDisplay({label, value, minWidth, action, isLoading, contact_info, type, maxWidth}) {
    const clickhandler = () => {
        if (action) {
            action()
        }
    }
    return <div className={`${classes.container} ${action ? classes.with_cursor : ''} ${contact_info ? classes.has_contact_boxes : ''}`} style={{minWidth: minWidth, maxWidth: maxWidth}} onClick={clickhandler} title={value}>
        <div className={classes.container_inner}>
            {label && <div className={classes.label}>{label}</div>}
            {value != null && value !== '' ? <div className={classes.value}>{value}</div> : null}
        </div>
        {contact_info && <div className={classes.contact_boxes}>
            {contact_info.phone && <IconBox type={'phone'} link={contact_info.phone} ext={contact_info.phone_ext}>
                <i className="ti ti-phone"></i>
            </IconBox>}
            {contact_info.cell_phone && <IconBox type={'phone'} link={contact_info.cell_phone}>
                <i className="ti ti-device-mobile"></i>
            </IconBox>}
            {contact_info.fax && <IconBox type={'fax'} link={contact_info.fax} fullInformation={contact_info}>
                <i className="ti ti-printer"></i>
            </IconBox>}
            {contact_info.email && <IconBox type={'mail'} link={contact_info.email} smsMail={type} fullInformation={contact_info}>
                <i className="ti ti-mail"></i>
            </IconBox>}
        </div>}
        {isLoading && <div className={classes.loader_container}>
            <span className="loader-circle"></span>    
        </div>}
    </div>
}